export class LeadAssignmentRulesApi {
  #http;

  #loansHttp;

  constructor(http, loansHttp) {
    this.#http = http;
    this.#loansHttp = loansHttp;
  }

  async getRules() {
    return this.#http.get('/api/lead-assignment-rules');
  }

  async createRule(dto) {
    return this.#http.post('/api/lead-assignment-rules', dto);
  }

  async updateRule({ ruleId, ...dto }) {
    return this.#http.put(`/api/lead-assignment-rules/${ruleId}`, dto);
  }

  async deleteRule(ruleId) {
    return this.#http.delete(`/api/lead-assignment-rules/${ruleId}`);
  }

  async reorderRules(dto) {
    return this.#http.put('/api/lead-assignment-rules/reorder', dto);
  }

  async getLeadMatchExpressionDefinition() {
    return this.#http.get('/api/lead-assignment-rules/expression-definitions');
  }

  // Pool-criteria schema is served by Skynet.Loans (candidate-user context), not the CRM
  // rules service — hence the /api/expressions/ namespace AND the Loans http client.
  async getLeadPoolCriteriaExpressionDefinition() {
    return this.#loansHttp.get('/api/expressions/lead-pool-criteria/definition');
  }
}
